<template>
  <v-card class="mb-12" elevation="0">
    <v-form>
      <v-row>
        <v-col md="6" cols="12">
          <label>عنوان دوره</label>
          <v-text-field v-model="dataModel.title" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>وضعیت دوره</label>
          <v-select clearable :items="statusItems" class="rounded-lg mt-2 sm-font400-14" item-text="title"
                    item-value="id"
                    hide-details solo v-model="dataModel.is_active"></v-select>
        </v-col>
        <v-col cols="12">
          <label>توضیحات</label>
          <v-textarea v-model="dataModel.description" class="rounded-lg mt-2 sm-font400-14" rows="7" hide-details
                      solo></v-textarea>
        </v-col>
        <v-col cols="12">
          <label>تعداد جلسات</label>
          <v-text-field v-model="dataModel.session_count" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col cols="12">
          <label>ظرفیت</label>
          <v-text-field v-model="dataModel.capacity" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details type="number"></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>قیمت دوره (ریال)</label>
          <v-text-field v-model="dataModel.price" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details type="number"></v-text-field>
          <span class="sm-font500-12" v-if="dataModel.price">{{ Number(dataModel.price)?.toLocaleString() }} تومان</span>
        </v-col>
        <v-col md="6" cols="12">
          <label>قیمت دوره (دلار)</label>
          <v-text-field v-model="dataModel.usd_price" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details type="number"></v-text-field>
          <span class="sm-font500-12" v-if="dataModel.usd_price">{{ Number(dataModel.usd_price)?.toLocaleString() }} دلار</span>
        </v-col>
        <v-col md="6" cols="12">
          <label>قیمت خارجی (ریال - کاربر خارجی)</label>
          <v-text-field v-model="dataModel.special_price" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details type="number"></v-text-field>
          <span class="sm-font500-12" v-if="dataModel.special_price">{{ Number(dataModel.special_price)?.toLocaleString() }} تومان</span>
        </v-col>
        <v-col md="6" cols="12">
          <label>لینک پرداخت خارجی (ریال)</label>
          <v-text-field v-model="dataModel.foreign_payment_rial_link" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label>لینک پرداخت خارجی (دلار)</label>
          <v-text-field v-model="dataModel.foreign_payment_usd_link" class="rounded-lg mt-2 pr-0 sm-font400-14" solo single-line
                        hide-details></v-text-field>
        </v-col>
        <v-col cols="6">
          <label>تصویر بنر دوره</label>
          <v-file-input v-model="dataModel.image" prepend-icon="" append-icon="mdi-upload"
                        class="rounded-lg mt-2 sm-font400-14" solo hide-details @change="changedImage">
            <template slot="prepend-inner" v-if="imagePreview !== '' && showImagePreview">
              <img width="40" :src="imagePreview"/>
            </template>
          </v-file-input>
        </v-col>
       
        <v-col cols="12" class="d-flex justify-end">
          <v-btn color="positive" class="textColor--text sm-font500-16 rounded-xl me-3" depressed height="48"
                 width="230" :loading="loading" @click="nextStep">
            ثبت و ادامه
          </v-btn>

          <v-btn width="230" height="48" depressed color="nagative" class="textColor--text sm-font500-16 rounded-xl"
                 @click="cancelProcess">
            انصراف
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import courseApi from "@/Services/modules/courses";

export default {
  name: "steps",
  props: {
    contentData: {
      type: Object,
      default: () => ({
        course_type: "Online_Offline",
        capacity: null,
      })
    },
    formType: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      dataModel: this.contentData,
      showImagePreview: true,
      imagePreview: null,
      showVideoPreview: true,
      videoPreview: null,
      statusItems: [{id: true, title: "فعال"}, {id: false, title: "غیرفعال"}],
    }
  },
  mounted() {
    this.imagePreview = this.dataModel.image
    delete this.dataModel.image
    this.videoPreview = this.dataModel.video
    delete this.dataModel.video
  },
  methods: {
    changedImage() {
      this.showImagePreview = false
    },
    changedVideo() {
      this.showVideoPreview = false
    },
    nextStep() {
      this.loading= true
      const formData = new FormData();
      formData.append("course_type", "Online_Offline");
      formData.append("title", this.dataModel.title ?? "");
      formData.append("is_active", this.dataModel.is_active ?? "");
      formData.append("description", this.dataModel.description ?? "");
      formData.append("session_count", this.dataModel.session_count ?? "");
      formData.append("capacity", this.dataModel.capacity ?? "");
      formData.append("category", ""); // explicit null/empty for backend
      formData.append("priority", ""); // always 0 for Online_Offline course type
      formData.append("price", this.dataModel.price ?? "");
      formData.append("usd_price", this.dataModel.usd_price ?? "");
      formData.append("use_price", this.dataModel.use_price ?? false);
      formData.append("special_price", this.dataModel.special_price ?? "");
      formData.append("foreign_payment_rial_link", this.dataModel.foreign_payment_rial_link ?? "");
      formData.append("foreign_payment_usd_link", this.dataModel.foreign_payment_usd_link ?? "");

      // v-file-input may return File or File[]; ensure we append actual File only
      const imageFile = Array.isArray(this.dataModel.image) ? this.dataModel.image[0] : this.dataModel.image;
      if (imageFile instanceof File) {
        formData.append("image", imageFile);
      }
      // For FormData: let browser set Content-Type with boundary; for object: use JSON
      const configHeader = {
        transformRequest: [(data, headers) => {
          if (data instanceof FormData) {
            delete headers["Content-Type"];
            return data;
          }
          if (data && typeof data === "object" && !(data instanceof File)) {
            headers["Content-Type"] = "application/json";
            return JSON.stringify(data);
          }
          return data;
        }]
      };
      if (this.formType === 'create') {
        courseApi.addStepToCourse(formData, configHeader).then(res => {
          this.$router.push(`/courses/additionalCrs/edit/${res.data.id}?step=2`)
        }).catch((err) => {
          console.log(err);
        }).finally(()=> {
          this.loading= false
        })
      } else {
        courseApi.editStepCourse({data: this.dataModel, id: this.$route.params.id}, configHeader).then(() => {
          this.$emit('nextStep', 2)
        }).catch((err) => {
          console.log(err);
        }).finally(()=> {
          this.loading= false
        })
      }
    },
    cancelProcess() {
      this.$router.push('/courses/course-list')
    }
  }
}
</script>

<style scoped></style>
